import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { SpinnerOptions } from "../../models/spinnerOptions";
import "./CustomSpinner.scss";

const CustomSpinner: React.FC<SpinnerOptions> = (props) => {
  const { colour, isFullScreen, isButton, isHideByClick } = props;

  const ModalSpinner = () => {
    const [show, setShow] = useState(true);

    useEffect(() => {
      document.body.setAttribute("aria-busy", "true");
      return () => {
        document.body.setAttribute("aria-busy", "false");
      };
    }, [show]);

    const handleClose = () => {
      setShow(false);
      document.body.setAttribute("aria-busy", "false");
    };
    return (
      <Modal
        backdropClassName="custom-modal-backdrop"
        className="custom-spinner-modal"
        show={show}
        onHide={isHideByClick ? handleClose : () => {}}
        id="ds-full-page-spinner"
        role="dialog"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="spinner spinner--dark mb-3"></div>
              <p>Vent, systemet arbejder</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  if (isFullScreen) {
    return <ModalSpinner />;
  } else {
    return <div className={`spinner ${colour ? colour : "spinner--dark"} ${isButton ? "absolute" : "relative"}`}></div>;
  }
};

export default CustomSpinner;
